import { type AxiosPromise } from "axios";
import React from "react";
import { Button, type ButtonProps } from "semantic-ui-react";
import { Modal } from "./index";
import { SomethingUnexpectedHappenedMessageBox } from "./MessageBox/SomethingUnexpectedHappenedMessageBox";

interface IDeleteDialogProps {
  isOpen?: boolean
  title?: string
  buttonLabel?: string
  message?: string | JSX.Element
  onDelete: () => Promise<any> | AxiosPromise<any>
  handleClose: () => void
  buttonProps?: Partial<ButtonProps>
  spinForever?: boolean
}

type State = typeof initialState;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const initialState = { deleting: false, hasError: false };

class DeleteDialog extends React.PureComponent<IDeleteDialogProps, State> {
  readonly state: State = {
    deleting: false,
    hasError: false
  };

  componentDidMount() {
    this.setState({ deleting: false });
    document.addEventListener("keydown", this.onKeyPressed);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.onKeyPressed);
  }

  onKeyPressed = (e: KeyboardEvent) => {
    if (this.props.isOpen && e.key === "Enter") {
      this.onDelete();
    }
  };

  onDelete = async () => {
    if (!this.state.deleting) {
      this.setState({ deleting: true, hasError: false });

      if (this.props.onDelete) {
        try {
          await this.props.onDelete();
          if (!this.props.spinForever) {
            this.setState({ deleting: false });
          }
        } catch {
          this.setState({ hasError: true, deleting: false });
        }
      }
    }
  };

  public render(): JSX.Element {
    const { isOpen, message, buttonLabel, buttonProps, title } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        width={"mini"}
        handleClose={this.props.handleClose}
        title={title || RESX.Buttons.btnDelete}
        className="force_z">

        <div className="grow1">
          {message}
        </div>

        {this.state.hasError && <SomethingUnexpectedHappenedMessageBox />}

        <div className="flex">
          <div className="grow1"></div>
          <div>
            <Button
              color="red"
              loading={this.state.deleting}
              onClick={this.onDelete}
              content={buttonLabel || RESX.Buttons.btnDelete}
              name="Delete"
              {...buttonProps}
            />
          </div>
        </div>

      </Modal>
    );
  }
}

export default DeleteDialog;
